/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateMovementDto } from '../models/CreateMovementDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class MovementsService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Registrar nuevo movimiento de activo
   * @returns any Movimiento registrado exitosamente
   * @throws ApiError
   */
  public movementsControllerCreate({
    assetId,
    requestBody,
  }: {
    /**
     * ID del activo
     */
    assetId: string,
    requestBody: CreateMovementDto,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/assets/{assetId}/movements',
      path: {
        'assetId': assetId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Datos inválidos`,
        403: `Sin permisos`,
        404: `Activo o ubicación no encontrados`,
      },
    });
  }
  /**
   * Listar movimientos de un activo
   * @returns any Lista de movimientos con paginación
   * @throws ApiError
   */
  public movementsControllerFindAll({
    assetId,
    page = 1,
    limit = 10,
    sortBy = 'createdAt',
    sortOrder = 'desc',
  }: {
    /**
     * ID del activo
     */
    assetId: string,
    /**
     * Número de página (empieza en 1)
     */
    page?: number,
    /**
     * Elementos por página
     */
    limit?: number,
    /**
     * Campo de ordenamiento
     */
    sortBy?: 'createdAt',
    /**
     * Dirección de ordenamiento
     */
    sortOrder?: 'asc' | 'desc',
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/assets/{assetId}/movements',
      path: {
        'assetId': assetId,
      },
      query: {
        'page': page,
        'limit': limit,
        'sortBy': sortBy,
        'sortOrder': sortOrder,
      },
      errors: {
        404: `Activo no encontrado`,
      },
    });
  }
}
